/** Run work after first paint / when the browser is idle. */
export const deferUntilIdle = (callback, timeoutMs = 2500) => {
  if (typeof window === "undefined") return () => {};

  let cancelled = false;
  let idleId;
  let timeoutId;

  const run = () => {
    if (cancelled) return;
    try {
      callback();
    } catch (e) {
      // ignore
    }
  };

  if (typeof window.requestIdleCallback === "function") {
    idleId = window.requestIdleCallback(run, { timeout: timeoutMs });
  } else {
    timeoutId = window.setTimeout(run, Math.min(timeoutMs, 1500));
  }

  return () => {
    cancelled = true;
    if (idleId != null && typeof window.cancelIdleCallback === "function") {
      window.cancelIdleCallback(idleId);
    }
    if (timeoutId != null) {
      window.clearTimeout(timeoutId);
    }
  };
};
